import { DvaReducer } from '@/models/shared';
import { AnyAction } from 'redux';
import { EffectsCommandMap, Subscription } from 'dva';
// import {
//   formatDate,
//   formatTime,
//   formatRelative,
//   formatNumber,
//   formatPlural,
//   formatMessage,
//   formatHTMLMessage,
//   setLocale,
//   getLocale,
// } from 'umi-plugin-react/locale';
// import { History } from 'history';
import { ConnectState } from '@/models/connect';
import { FI18n } from '@freelog/tools-lib';
import { defaultResourceTypeCodesFilterAll } from '@/models/shared/resourceListHelpers';

export interface GlobalModelState {
  globalLoading: boolean;
  locale: 'zh-CN' | 'en-US' | 'pt-BR';
  route: any;
  routerHistories: {
    hash: string;
    key: string;
    pathname: string;
    query: { [key: string]: string };
    search: string;
    state: any;
  }[];
  // backgroundColor: string;
}

export interface ChangeAction extends AnyAction {
  type: 'change' | 'global/change';
  payload: Partial<GlobalModelState>;
}

// export interface SetLocaleAction extends AnyAction {
//   type: 'global/setLocale';
//   payload: GlobalModelState['locale'];
// }

export interface PushRouterAction extends AnyAction {
  type: 'pushRouter';
  payload: GlobalModelState['routerHistories'][number];
}

export interface GlobalModelType {
  namespace: 'global';
  state: GlobalModelState;
  effects: {
    // setLocale: (action: SetLocaleAction, effects: EffectsCommandMap) => void;
    pushRouter: (action: PushRouterAction, effects: EffectsCommandMap) => void;
  };
  reducers: {
    change: DvaReducer<GlobalModelState, ChangeAction>;
  };
  subscriptions: {
    setup: Subscription;
    historyListen: Subscription;
    activatedWindow: Subscription;
    readyI18n: Subscription;
  };
}

const Model: GlobalModelType = {
  namespace: 'global',
  state: {
    globalLoading: true,
    locale: 'zh-CN',
    route: null,
    routerHistories: [],
    // backgroundColor: '',
  },
  effects: {
    // * setLocale({ payload }: SetLocaleAction, { call, put }: EffectsCommandMap) {
    //   yield call(setLocale, payload);
    //   // yield call(window.localStorage.setItem, 'local', payload);
    //   yield put<ChangeAction>({
    //     type: 'change',
    //     payload: {
    //       locale: payload,
    //     },
    //   });
    // },
    * pushRouter({ payload }: PushRouterAction, { put, select }: EffectsCommandMap) {
      const { routerHistories } = yield select(({ global }: ConnectState) => ({
        routerHistories: global.routerHistories,
      }));
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          routerHistories: [
            ...routerHistories,
            payload,
          ],
        },
      });
    },
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({ dispatch, history }) {
      // history.listen((listener) => {
      //   // console.log(listener, 'listener098phijnoweklf');
      //   dispatch<PushRouterAction>({
      //     type: 'pushRouter',
      //     payload: listener as any,
      //   });
      // });
    },
    historyListen({ dispatch, history }) {
      history.listen((listener) => {
        // console.log(listener, 'listener098phijnoweklf');
        dispatch<PushRouterAction>({
          type: 'pushRouter',
          payload: listener as any,
        });
      });
    },
    activatedWindow({ dispatch }) {
      window.document.addEventListener('visibilitychange', function() {
        // console.log(document.hidden, 'document.hidden9032rweopfdslj.,');
        // Modify behavior...

      });

      window.addEventListener('pagehide', event => {
        if (event.persisted) {
          /* the page isn't being discarded, so it can be reused later */
        }
      }, false);
    },
    readyI18n({ dispatch }) {
      FI18n.i18nNext.ready().then(() => {
        const rtc = defaultResourceTypeCodesFilterAll();
        dispatch({
          type: 'collectionListPage/change',
          payload: { resourceTypeCodes: rtc },
        });
        dispatch({
          type: 'resourceListPage/change',
          payload: { resourceTypeCodes: rtc },
        });
        dispatch({
          type: 'resourceCollectPage/change',
          payload: { resourceTypeCodes: rtc },
        });
        dispatch<ChangeAction>({
          type: 'change',
          payload: {
            globalLoading: false,
          },
        });
      });
    },
  },

};

export default Model;
